export default __webpack_public_path__ + "static/media/SC42.832b4c7a.jpg";